var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.143V14.5C18 15.314 17.619 16.01 17.09 16.557C16.567 17.099 15.857 17.541 15.058 17.891C13.456 18.591 11.314 19 9 19C6.686 19 4.544 18.592 2.942 17.891C2.143 17.541 1.433 17.099 0.91 16.557C0.425 16.057 0.0649999 15.429 0.0079999 14.701L0 14.5V13.143C0.464667 13.4083 0.962667 13.64 1.494 13.838C3.524 14.589 6.179 15.008 9 15.008C11.821 15.008 14.476 14.589 16.506 13.838C16.9047 13.69 17.2843 13.5223 17.645 13.335L18 13.143ZM0 7.643C0.464667 7.90833 0.962667 8.14 1.494 8.338C3.524 9.089 6.179 9.508 9 9.508C11.821 9.508 14.476 9.089 16.506 8.338C17.0223 8.14783 17.522 7.91537 18 7.643V10.748C17.3362 11.2609 16.5985 11.6702 15.812 11.962C14.057 12.612 11.648 13.009 9 13.009C6.353 13.009 3.944 12.612 2.188 11.962C1.40151 11.6702 0.663794 11.2609 0 10.748V7.643ZM9 0C11.314 0 13.456 0.408 15.058 1.109C15.857 1.459 16.567 1.901 17.09 2.443C17.575 2.943 17.935 3.571 17.992 4.299L18 4.5V5.248C17.3362 5.76091 16.5985 6.17023 15.812 6.462C14.057 7.112 11.648 7.509 9 7.509C6.353 7.509 3.944 7.112 2.188 6.462C1.51199 6.21085 0.8716 5.87267 0.283 5.456L0 5.248V4.5C0 3.686 0.381 2.99 0.91 2.443C1.433 1.901 2.143 1.459 2.942 1.109C4.544 0.409 6.686 0 9 0Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiece);
export default __webpack_public_path__ + "static/media/piece.bfa56523238b1729222a193825f57188.svg";
export { ForwardRef as ReactComponent };